angular
    .module('multicrm')
    .directive('tableInvisibleOnLoading', function ($transitions) {
        return {
            restrict: 'A',
            link: function ($scope, $element) {
                let onBefore = $transitions.onBefore({}, () => $element.hide())
                let onFinish = $transitions.onFinish({}, () => $element.show())
                let onError = $transitions.onError({}, () => $element.show())

                $scope.$on('$destroy', () => {
                    onBefore()
                    onFinish()
                    onError()
                })
            }
        }
    })
    .component('tableLoadingSpinner', {
        template: '<div class="table-loading-spinner" ng-if="$ctrl.isLoading"><i class="fa fa-spinner fa-spin fa-2xl"></i></div>',
        bindings: {
            items: '<'
        },
        controller: function ($transitions) {

            this.isLoading = false;

            let onBefore = $transitions.onBefore({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = true
                }
            })

            let onFinish = $transitions.onFinish({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = false
                }
            })

            let onError = $transitions.onError({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = false
                }
            })

            this.$onDestroy = () => {
                onBefore()
                onFinish()
                onError()
            }
        }
    })
    .component('stateLoadingSpinner', {
        template: "<div class=\"state-loading-spinner\" ng-if=\"$ctrl.isLoading\"><i class=\"fa fa-spinner fa-spin fa-2xl\"></i></div>",
        controller: function ($transitions) {

            this.isLoading = false

            let onBefore = $transitions.onBefore({}, transition => {
                if (transition.from() !== transition.to()) {
                    this.isLoading = true
                }
            })

            let onFinish = $transitions.onFinish({}, transition => {
                if (transition.from() !== transition.to()) {
                    this.isLoading = false
                }
            })

            let onError = $transitions.onError({}, transition => {
                if (transition.from() !== transition.to()) {
                    this.isLoading = false
                }
            })

            this.$onDestroy = () => {
                onBefore()
                onFinish()
                onError()
            }
        }
    })
    .component('tableDataLoading', {
        template: '<div class="table-loading-spinner" ng-if="$ctrl.isLoading"><i class="fa fa-spinner fa-spin fa-lg fa-2xl"></i></div>',
        bindings: {
            promise: '<'
        },
        controller: function ($transitions) {
            this.$onChanges = () => {
                this.isLoading = true;
                let obj = this.promise

                if(obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function') {
                    this.promise.then(() => {

                    }).finally(() => {
                        this.isLoading = false;
                    })
                }
            }
        }
    })
    .component('tableNoData', {
        template: '<div class="table-no-data" ng-if="$ctrl.items && $ctrl.items.length == 0 && !$ctrl.isLoading"><span translate="no-records"></span></div>',
        bindings: {
            items: '<'
        },
        controller: function ($transitions) {

            this.isLoading = false

            let onBefore = $transitions.onBefore({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = true
                }
            })

            let onFinish = $transitions.onFinish({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = false
                }
            })

            let onError = $transitions.onError({}, transition => {
                if (transition.from() === transition.to()) {
                    this.isLoading = false
                }
            })

            this.$onDestroy = () => {
                onBefore()
                onFinish()
                onError()
            }
        }
    })
